/**
 * COPSOQ III — Partie 3 : questions médicales.
 *
 * Non scorée : données de santé du répondant (`donnees.sante`), hors de toute
 * échelle COPSOQ.
 */

import { OUI_NON, type EcranQuestions } from "./copsoq3-ecrans";

const CONSOMMATION = [
  "Excessive",
  "Importante",
  "Moyenne",
  "Modérée",
  "Nulle ou presque",
] as const;

export const copsoq3EcransPartie3: readonly EcranQuestions[] = [
  {
    titre: "Au cours des 12 derniers mois",
    questions: [
      {
        name: "arrets_nombre",
        question:
          "Combien avez-vous eu d'arrêts de travail (si vous êtes SPP) ou d'arrêts temporaires (si vous êtes SPV) pour des motifs liés à votre activité de SP ?",
        type: "nombre",
        min: 0,
        max: 99,
      },
      {
        name: "arret_plus_long_jours",
        condition: { question: "arrets_nombre", superieurA: 0 },
        question:
          "Quelle était la durée de votre arrêt le plus long (en jours) ?",
        type: "nombre",
        min: 1,
        max: 365,
      },
      {
        name: "traitements_medicamenteux",
        question:
          "Avez-vous pris des traitements médicamenteux pour des motifs liés à votre activité de SP ?",
        type: "choix",
        options: OUI_NON,
      },
      {
        name: "douleurs_physiques",
        question:
          "Avez-vous ressenti des douleurs physiques liées à votre activité de SP ?",
        type: "choix",
        options: OUI_NON,
      },
      {
        name: "somniferes_tranquillisants",
        question:
          "Avez-vous pris des somnifères ou des tranquillisants pour des motifs liés à votre activité de SP ?",
        type: "choix",
        options: OUI_NON,
      },
      {
        name: "consultation_generaliste",
        question:
          "Avez-vous consulté un médecin généraliste pour des motifs liés à votre activité de SP ?",
        type: "choix",
        options: OUI_NON,
      },
      {
        name: "consultation_generaliste_frequence",
        condition: { question: "consultation_generaliste", valeur: "Oui" },
        question: "À quelle fréquence ?",
        type: "choix",
        options: [
          "Moins d'une fois par an",
          "Une fois par an",
          "Plus d'une fois par an",
        ],
      },
    ],
  },
  {
    titre: "Habitudes de vie",
    questions: [
      {
        name: "tabac",
        question: "Je fume :",
        type: "choix",
        options: [
          "Jamais",
          "Très occasionnellement (quelques cigarettes par an)",
          "Occasionnellement (quelques cigarettes par mois)",
          "Régulièrement (plusieurs cigarettes par semaine)",
          "Quotidiennement",
        ],
      },
      {
        name: "alcool",
        question: "Selon moi, ma consommation d'alcool est :",
        type: "choix",
        options: CONSOMMATION,
      },
      {
        name: "drogue",
        question: "Selon moi, ma consommation de drogue est :",
        type: "choix",
        options: CONSOMMATION,
      },
      {
        name: "activite_physique",
        question:
          "J'ai une activité physique générale (hors activité professionnelle) :",
        type: "choix",
        options: [
          "Moins d'une fois par semaine",
          "1 à 2 fois par semaine",
          "3 à 4 fois par semaine",
          "5 à 6 fois par semaine",
          "Tous les jours",
        ],
      },
    ],
  },
];
